import React from 'react';
import { loadGraphQLData } from '../page';
import MLP from './mlp-container';

export default {
    component: MLP,
    loadData: loadGraphQLData,
};
